import { datadogLogs } from '@datadog/browser-logs'
import { DataService } from './dataService'

const loadData = async (path: string, manage: number = 0) => {
  try {
    const _dataService = new DataService()
    const filter = {
        url: path,
        filter: {
          origin: "epayco",
          manage
        }
    }
    const resposeData = await _dataService.post(`/vende/load`, filter)
    return resposeData.data
  } catch (err) {
      datadogLogs.logger.info('error request callData', { name: 'post /vende/load', body: path, error: (err as Error).message })
      return null
  }
};
export default loadData;